import _ from "lodash";
import {
  GET_ADMINISTRATION_THEREFORE_KEYWORDS_BY_FIELD_NO,
} from "./actions";

export function AdministrationThereforeKeywordsByFieldNoReducer(state = [], action) {
  switch (action.type) {
    case `${GET_ADMINISTRATION_THEREFORE_KEYWORDS_BY_FIELD_NO}_FULFILLED`: {
      const { category_no, field_no } = action.meta;
      const keywords = _.get(action.payload, "data", []);
      const entry = { category_no, field_no, keywords };

      const existingIndex = _.findIndex(
        state,
        (item) => _.toString(item.category_no) === _.toString(category_no) && _.toString(item.field_no) === _.toString(field_no)
      );

      if (existingIndex >= 0) {
        const newState = _.clone(state);
        newState[existingIndex] = entry;
        return newState;
      }
      return _.concat(state, entry);
    }
    case `${GET_ADMINISTRATION_THEREFORE_KEYWORDS_BY_FIELD_NO}_REJECTED`: {
      return state;
    }
    default:
      return state;
  }
}
